import { createCardPR } from '@lc/interface/card/pr/factory';

export const PRMeta = [
	createCardPR(
		121,
		1,
		`INVIGORATE YOUR EMPLOYEES BY GOING TO MARS`,
		`“I’M A MAN OF THE PEOPLE.”`
	),
	createCardPR(
		122,
		1,
		`CALL ANYONE WHO DISAGREES WITH YOU MEAN NAMES`,
		`“FASCIST!”`
	),
	createCardPR(
		123,
		1,
		`PUT “MADE IN USA” ON IMPORTED PRODUCTS`,
		`‘“THESE FIT RIGHT OVER THE ‘MADE IN CHINA’ LABELS!”`
	),
	createCardPR(
		124,
		1,
		`PUT WATER TURBINE AS CENTERFOLD OF SPORTS MAGAZINE’S SWIMSUIT EDITION`,
		`“BILLY PUT THAT DOWN. THAT’S DAD’S.”`
	),
	createCardPR(
		125,
		1,
		`GET A SERVICE DOG FOR YOUR RANGE ANXIETY`,
		`“WE KEEP HIM IN THE FRUNK.”`
	),
	createCardPR(
		126,
		1,
		`REVEAL NEW RENEWABLE TECHNOLOGY WITH LIVE-STREAMING KEYNOTE EVENT`,
		`“THIS WIND TURBINE BEANIE WILL REVOLUTIONIZE THE INDUSTRY!”`
	),
	createCardPR(
		127,
		1,
		`HIRE TEAM OF “EXPERTS” TO BACK UP ALL THE CLAIMS YOU’VE MADE`,
		`“WE WON THE GOLD MEDAL FOR MENTAL GYMNASTICS.”`
	),
	createCardPR(
		128,
		2,
		`NEW CLIMATE RESEARCH AVAILABLE FOR FREE`,
		`“TEAR. DOWN. THAT. PAYWALL!”`
	),
	createCardPR(
		129,
		2,
		`ADVERTISE AS “FAMILY BUSINESS” DESPITE HAVING 700,000 EMPLOYEES`,
		`“THE DINNER TABLE IS HUGE.”`
	),
	createCardPR(
		130,
		2,
		`WIN NO-BELL PEACE PRIZE`,
		`“THIS ORCHESTRA IS MISSING SOMETHING.”`
	),
	createCardPR(
		131,
		2,
		`MAKE COMPANY MASCOT A PLANT`,
		`“YEAH, THERE’S A GUY IN THE SUIT. NO, HE’S NOT ALLOWED TO TALK.”`
	),
	createCardPR(
		132,
		2,
		`DISCOVER 5G TACHYONS IN YOUR BLOOD`,
		`“YES, BUT WHAT IF THE TACHYONIC ANTI-TELEPHONE WAS ON A POWERFUL 5G NETWORK?”`
	),
];
